import React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import NoSsr from '@material-ui/core/NoSsr';
import classNames from 'classnames';
import * as styles from './styles/styles.module.scss';

function SsrFallback(props) {
  const tabClasses = Object.values(props.tabClasses).join(' ');
  const sliderClasses = Object.values(props.slidingTabsClasses).join(' ');

  return (
    <div className={`${styles.ssrFallback} ${styles.flexContainer} ${sliderClasses}`}>
      {props.tabs.map((tab, idx) => (
        <div key={tab.label} className={classNames(styles.ssrTab, props.activeIndex === idx && styles.activeSsrTab, tabClasses)}>
          {tab.label}
        </div>
      ))}
    </div>
  );
}

const SlidingTabs = props => {
  return (
    <NoSsr fallback={<SsrFallback {...props} />}>
      <Tabs
        classes={{
          ...{
            root: styles.tabsRoot,
            indicator: styles.tabsIndicator,
            scroller: styles.tabsScroller,
            scrollButtons: styles.tabsScrollButtons,
            flexContainer: styles.flexContainer
          },
          ...props.slidingTabsClasses
        }}
        value={props.activeIndex}
        onChange={props.onChange}
        variant={props.variant}
        scrollButtons={props.scrollButtons}
        data-testid="rootTab"
        aria-label="scrollable auto tabs"
      >
        {props.tabs.map((tab, idx) => (
          <Tab
            classes={{
              ...{
                root: styles.tabRoot,
                wrapper: props.activeIndex === idx ? styles.selectedTabWrapper : styles.tabWrapper,
                textColorInherit: styles.textColorInherit
              },
              ...props.tabClasses
            }}
            disableRipple
            key={tab.label}
            label={tab.label}
            tabIndex={0}
            data-testid="slidingtabs"
          />
        ))}
      </Tabs>
    </NoSsr>
  );
};

SlidingTabs.propTypes = {
  onChange: PropTypes.func,
  variant: PropTypes.string,
  activeIndex: PropTypes.number,
  scrollButtons: PropTypes.string,
  tabClasses: PropTypes.objectOf(PropTypes.any),
  slidingTabsClasses: PropTypes.objectOf(PropTypes.any),
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string
    })
  )
};

SlidingTabs.defaultProps = {
  onChange: () => {},
  variant: 'scrollable',
  scrollButtons: 'on',
  activeIndex: 0,
  tabs: [],
  tabClasses: {},
  slidingTabsClasses: {}
};

export default SlidingTabs;
